import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

const dummyContraindications = [
  { id: '1', condition: 'Liver Disease' },
  { id: '2', condition: 'Severe Alcoholism' },
  { id: '3', condition: 'Allergy to Acetaminophen' },
];

const Contraindications = () => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Contraindications</CardTitle>
        <div>
          {dummyContraindications.map((contra) => (
            <p key={contra.id} className="text-muted mb-2">
              • {contra.condition}
            </p>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default Contraindications;
